import { constant } from "common/constant";
import * as yup from "yup";
import { nameFieldValidation, phoneNumberValidation } from "common/utils/validationHelpers";

export const ApplicationSchema = yup.object({
  postingTitle: yup.string().required(constant.requiredJob),
  name: yup.string().required("Name is required"),
  email: yup.string().email(constant.invalidEmail).nullable(),
  phone: phoneNumberValidation(),
  city: yup.string(),
  experienceYears: yup.string().nullable(),
  state: yup.string(),
  noticePeriod: yup.string(),
  status: yup.string().required(constant.requiredStatus),
  remarks: yup.string().nullable().max(1000, "Remarks cannot exceed 1000 characters"),
  applicationSource: yup.string().nullable(),
  resume: yup.string().nullable(),
  coverLetter: yup.string().nullable(),
});
